/* Shim dla antd v4 na React 19: dodaje brakujące ReactDOM.render i unmountComponentAtNode
   Używa require('react-dom'), aby obejść weryfikację eksportów ESM w Webpack 5. */
import { createRoot } from 'react-dom/client';
import type React from 'react';

/* eslint-disable @typescript-eslint/no-var-requires */
const ReactDOMCompat: any = require('react-dom'); // CJS require => można dopisać własności

// Trzymamy rooty per kontener, żeby poprawnie unmountować
const roots = new WeakMap<Element, ReturnType<typeof createRoot>>();

if (!ReactDOMCompat.render) {
  Object.defineProperty(ReactDOMCompat, 'render', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: (node: React.ReactNode, container: Element) => {
      let root = roots.get(container);
      if (!root) {
        root = createRoot(container);
        roots.set(container, root);
      }
      root.render(node as any);
      return null; // zgodnie z dawnym signaturem
    },
  });
}

if (!ReactDOMCompat.unmountComponentAtNode) {
  Object.defineProperty(ReactDOMCompat, 'unmountComponentAtNode', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: (container: Element) => {
      const root = roots.get(container);
      if (root) {
        root.unmount();
        roots.delete(container);
        return true;
      }
      return false;
    },
  });
}